import React from "react";
import "./Counselling_Process.css";
import Common_Title from "../../common/common-title/Common_Title";

const Counselling_Process = ({careerprocess}) => {
  const steps = [
    {
      number: "01",
      title: "Career Assessment",
      text: "Students complete Aptitude, Personality, and Interest tests.",
    },
    {
      number: "02",
      title: "Result Analysis",
      text: "Automated scoring followed by detailed counselor review.",
    },
    {
      number: "03",
      title: "One-to-One Counselling Session",
      text:
        "Personalized discussion to understand goals, strengths, and opportunities.",
    },
    {
      number: "04",
      title: "Career Recommendations",
      text: "Career streams, courses, colleges, and exam guidance.",
    },
    {
      number: "05",
      title: "Detailed Report",
      text:
        "Detailed PDF report with strengths, weaknesses, and career roadmap.",
    },
  ];
  return (
    <section className="Counselling_Process">
      <div className="container">
        <Common_Title title="Our Career Counselling Process" />

        <div className="process_box_holder">
          <div className="row justify-content-center g-5">
            
            {careerprocess?.map((step, index) => (
              <div className="col-lg-4 col-md-6 col-sm-6"  key={index}>
                <div className="step_card">
                  <h3 className="step_no">{index + 1}</h3>
                  <h5 className="step_title">{step?.name}</h5>
                  <p className="step_text">{step?.description.replace(/<\/?[^>]+(>|$)/g, "")}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Counselling_Process;
